<div [ngClass]="activeToggleClasses">
  <div class="wpdh-container">
    <router-outlet></router-outlet>
  </div>
</div>
<app-breakpoint></app-breakpoint>
@if (globals.isBrowser) {
<app-search-window></app-search-window>
}
@if (globals.isBrowser && loadingContent) {
<div class="initial-loader-overlay" role="status" aria-live="polite" aria-atomic="true" aria-busy="true">
  <span class="initial-loader-overlay__sr">Loading content</span>
  <wp-spinner size="40" background="light" [loading]="true"></wp-spinner>
</div>
}
